// Module
var code = "<oc-menu menu-items=\"menuItems['settings']\" allow-search=\"true\"></oc-menu>";
// Exports
module.exports = code;